import { GoogleTagManager } from '@iwoca/frontend-tracking-library';
import _ from 'lodash';

import * as personalInformationSchemas from './schema';
import { updateStepData } from '../../actions';

export default (values, dispatch, props) =>
    new Promise((resolve, reject) => {
        const fieldIdentifier = _.get(props, 'form._asyncValidating');
        const fieldName = _.replace(fieldIdentifier, /.+\[.+\]\./, '');

        const person = _.find(values.people, (person) => {
            return _.includes(person.roles, 'applicant');
        });

        personalInformationSchemas.personalInfoDE
            .validate(person, {
                abortEarly: false
            })
            .then(() => {
                const step = {
                    id: 'personalInformation',
                    valid: true
                };
                dispatch(updateStepData(step));
                GoogleTagManager.trackFormField({
                    formName: step.id,
                    fieldName,
                    interaction: 'Change'
                });
                resolve();
            })
            .catch((errors) => {
                const step = {
                    id: 'personalInformation',
                    valid: false
                };
                let formErrors = {
                    people: [
                        errors.inner.reduce(
                            (memo, err) =>
                                _.setWith(memo, err.path, err.message),
                            {}
                        )
                    ]
                };
                dispatch(updateStepData(step));
                GoogleTagManager.trackFormField({
                    formName: step.id,
                    fieldName,
                    interaction: 'Error'
                });
                reject(formErrors);
            });
    });
